import { render, staticRenderFns } from "./project_loss_provisions.vue?vue&type=template&id=1b185d42&"
import script from "./project_loss_provisions.vue?vue&type=script&lang=js&"
export * from "./project_loss_provisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports